import { render, staticRenderFns } from "./TaskDescription.vue?vue&type=template&id=4f271292&"
import script from "./TaskDescription.vue?vue&type=script&lang=ts&"
export * from "./TaskDescription.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports